export default __webpack_public_path__ + "041a6c575b4e4160ed087ace6f817436.png";